export default "assets/images/icons/next-17073525.svg";